import {
  ADD_ROLE_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  RESET_ROLE_STATE,
  FETCH_ROLES_REQUEST,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  ADD_ROLE,
  EDIT_ROLE,
  DELETE_ROLE,
  SEARCH_ROLES,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  FETCH_ROLE_DETAILS_REQUEST,
  FETCH_ROLE_DETAILS_SUCCESS,
  FETCH_ROLE_DETAILS_FAILURE,
} from '../RoleTypes/RoleTypes';

const initialState = {
  loading: false,
  success: false,
  roleDetails: null,
  error: null,
  updateLoading: false,
  deleteLoading: false,
  roles: [],
  filteredRoles: [],
  searchQuery: '',
};

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
        updateLoading: false,
        deleteLoading: false,
        success: false,
        error: null,
      };

    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: false,
        success: action.payload,
        error: null,
      };

    case ADD_ROLE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        updateLoading: false,
        deleteLoading: false,
        error: action.payload,
      };

    case RESET_ROLE_STATE:
      return {
        ...state,
        success: false,
        updateLoading: false,
        deleteLoading: false,
        loading: false,
        error: null,
      };

    case FETCH_ROLES_REQUEST:
      return {
        ...state,
        loading: true,
        updateLoading: false,
        deleteLoading: false,
        error: null,
      };

    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: false,
        roles: action.payload.map((role) => ({
          ...role,
          permissions:
            typeof role.permissions === 'string'
              ? JSON.parse(role.permissions)
              : role.permissions,
        })),
      };

    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: false,
        error: action.payload,
      };

    case ADD_ROLE:
      return {
        ...state,
        updateLoading: false,
        deleteLoading: false,
        roles: [...state.roles, action.payload],
      };

    case EDIT_ROLE:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role.roleName === action.payload.roleName ? action.payload : role
        ),
        updateLoading: false,
        deleteLoading: false,
      };

    case DELETE_ROLE:
      return {
        ...state,
        updateLoading: false,
        deleteLoading: false,
        roles: state.roles.filter((role) => role.roleName !== action.payload),
      };

    case SEARCH_ROLES:
      return {
        ...state,
        searchQuery: action.payload,
        roles: state.roles.filter((role) =>
          role.roleName.toLowerCase().includes(action.payload.toLowerCase())
        ),
        updateLoading: false,
        deleteLoading: false,
      };
    case UPDATE_ROLE_REQUEST:
      return {
        ...state,
        loading: false,
        updateLoading: true,
        deleteLoading: false,
        error: null,
      };
    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updateLoading: false,
        deleteLoading: false,
        error: null,
        roles: state.roles.map((role) =>
          role.id === action.payload.id ? action.payload : role
        ),
      };

    case UPDATE_ROLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        updateLoading: false,
        deleteLoading: false,
        success: false,
      };
    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: true,
        error: null,
        success: false,
      };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        updateLoading: false,
        deleteLoading: false,
        roles: state.roles.filter((role) => role.id !== action.payload),
      };
    case DELETE_ROLE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        updateLoading: false,
        deleteLoading: false,
        error: action.payload,
      };

    case FETCH_ROLE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        updateLoading: false,
        deleteLoading: false,
        error: null,
      };

    case FETCH_ROLE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: false,
        roleDetails: action.payload,
      };

    case FETCH_ROLE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        updateLoading: false,
        deleteLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default rolesReducer;
